<template>
  <div class="iframe-page">
    <AppNavBar :title="pageTitle" :background-color="backgroundColor" />
    <div class="iframe-wrap">
      <iframe ref="iframeRef" class="iframe" :src="verificationUrl.url" />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import AppNavBar from "@/components/AppNavBar.vue";
import { getRouteState } from "@/utils/route-state";

const { t } = useI18n();
const route = useRoute();
const iframeRef = ref(null);
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  url: {
    type: String,
    default: "",
  },
  backgroundColor: {
    type: String,
    default: "",
  },
});
const pageState = computed(() => getRouteState(route, "iframe-page", {}));
const pageTitle = computed(
  () =>
    String(props.title || pageState.value.title || "").trim() ||
    t("common.userAgreement"),
);

const verificationUrl = computed(() => ({
  url: props.url || pageState.value.url || "",
}));
const backgroundColor = computed(
  () => props.backgroundColor || pageState.value.backgroundColor || "",
);
</script>
<style>
html {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
</style>

<style lang="scss" scoped>
.iframe-page {
  height: var(--app-viewport-height);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .iframe-wrap {
    flex: 1;
    min-height: 0;
    overflow: auto;
    background: #fff;
  }
}

.iframe {
  display: block;
  width: 100%;
  height: var(--app-viewport-height);
  border: 0;
  background: #fff;
  padding-bottom: 20px;
}
</style>
